<div class="viewPortal">
    <div class="leftBg">
        <logzy-img-loader src="assets\images\web-portal\arcon_white_logo.svg"></logzy-img-loader>
        <img *ngIf="step1" src="assets\images\web-portal\Gif_Portal.gif" class="bottomImg" alt="">

        <div *ngIf="!step1" class="astepper">
            <div class="stepTitlebox">
                <div class="stepTitle" style="cursor:pointer;" [class.activeText]="step1" (click)="setStep('step1')">
                    <span *ngIf="step1" class="cstepNum">1</span> <i class="flaticon-checked" *ngIf="!step1"></i>
                    <span class="cstepspn">YOUR REQUIREMENTS</span>
                </div>
            </div>
            <div class="stepTitlebox">
                <div class="stepTitle" style="cursor:pointer;" [class.activeText]="step2" (click)="setStep('step2')">
                    <span class="cstepNum">2</span><span class="cstepspn">BASIC DETAILS</span>
                </div>
            </div>
            <div class="stepTitlebox">
                <div class="stepTitle" [class.activeText]="step3">
                    <span class="cstepNum">3</span><span class="cstepspn">COMPLETION</span>
                </div>
            </div>
        </div>

        <img *ngIf="step2" src="assets\images\web-portal\baiscDetails.gif" class="bottomImg" alt="">
        <img *ngIf="step3" src="assets\images\web-portal\completion.gif" class="bottomImg" alt="">
    </div>
    <mat-card>
        <mat-card-content class="position-relative">
            <div class="wrap" *ngIf="!isEmailVerified">
                <div class="stepHead">
                    <label *ngIf="step1">Requirements</label>
                    <label *ngIf="!step1" style="display: flex; flex-wrap: wrap;
                    column-gap: 1em;">Your Requirement <mat-chip
                            class="secondary-chip ">{{requestObj?.request_type?.name_display}} : <span
                                class="transaction"> {{requestObj?.transaction_type}} </span></mat-chip>
                        <mat-chip class="primary-chip " *ngIf="requestObj.request_type?.dev_name !== 'lease'">
                            <ng-container *ngIf="requestObj.request_type?.dev_name=='one_way'">
                                {{requestObj?.transaction_type=='use'?'Use':'Supply'}} Containers
                            </ng-container>
                            <ng-container *ngIf="requestObj.request_type?.dev_name=='buy_sell'">
                                {{requestObj?.transaction_type=='use'?'Buy':'Sell'}} Containers
                            </ng-container>
                        </mat-chip></label>
                    <button *ngIf="!step1" mat-icon-button class="editRequest" (click)="setStep('step1')">
                        <i *ngIf="!step3" class="flaticon-pencil" matTooltip="Edit your requirements"></i></button>
                </div>
                <div fxFlex="100" class="inputs " *ngIf="step1">
                    <!-- Request Type -->
                    <app-select-field [isEditable]="isRequestEditable" [ngModel]="requestObj.request_type"
                        [name]="'request_type'" (ngModelChange)="getLocationLabelsByRequestType($event)"
                        [idField]="null" [displayField]="'name_display'" [options]="requestTypeList?.results"
                        fxFlex="12.3em" [(errors)]="requestObj.error.request_type">
                    </app-select-field>

                    <!-- Transaction Type -->
                    <ng-container *ngIf="!isRequestEditable">
                        <div>
                            <ng-container *ngIf="requestObj.request_type?.dev_name!='buy_sell'">
                                {{requestObj?.transaction_type=='use'?'Use':'Supply'}} Containers
                            </ng-container>
                            <ng-container *ngIf="requestObj.request_type?.dev_name=='buy_sell'">
                                {{requestObj?.transaction_type=='use'?'Buy':'Sell'}} Containers
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isRequestEditable">
                        <div fxLayout="column">
                            <mat-button-toggle-group *ngIf="requestObj.request_type" class="togglebtn1"
                                style="margin-top:7px;" aria-label="Platform" [ngModel]="requestObj.transaction_type"
                                (ngModelChange)="getLocationLabelByTransactionType($event)">
                                <ng-container *ngFor="let btn of transactionTypeBtns">
                                    <ng-container
                                        *ngIf="!(requestObj.request_type?.dev_name=='lease' && btn.dev_value=='supply')">
                                        <mat-button-toggle
                                            *ngIf="btn.group == 'LeadRequestTransactionTypes_'+ requestObj.request_type?.dev_name"
                                            (click)="selectTransactionType(btn.dev_value)" [value]='btn.dev_value'>
                                            {{btn.value}}
                                        </mat-button-toggle>
                                    </ng-container>
                                </ng-container>
                            </mat-button-toggle-group>
                            <div class="errors" *ngIf="requestObj.error.transaction_type?.length">
                                <ul>
                                    <li *ngFor="let error of requestObj.error.transaction_type">
                                        {{error}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>

                    <div fxFlex="100" class="inputs">
                        <div fxFlex="100" class="leaseRequest">
                            <div class="leasebox">
                                <div class="inputs" *ngFor="let requirement of requestObj.requirements, let i=index">
                                    <!-- Quantity -->
                                    <div fxFlex="12.3em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Quantity*</span>
                                        </div>
                                        <app-number-field [isEditable]="true"
                                            [(ngModel)]="requestObj.requirements[i].quantity" [name]="'quantity'+i"
                                            [noDecimal]="true"
                                            [errors]="requestObj.error?.requirements?.length ? requestObj.error?.requirements[i]?.quantity : []"
                                            [minValue]="1" [maxValue]="9999" [maxlength]="4"
                                            [containerNum]="true"></app-number-field>
                                    </div>

                                    <!-- Container Size Type -->
                                    <div fxFlex="12.3em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Container Type*</span>
                                        </div>
                                        <app-mat-auto-search [isEditable]="true" fxFlex="100" class="containerType"
                                            [(ngModel)]="requestObj.requirements[i].container_size_type"
                                            [errors]="requestObj.error?.requirements?.length ? requestObj.error?.requirements[i]?.container_size_type : []"
                                            [idField]="null" displayField='display_name' [trim]="true"
                                            [searchIcon]="true" [clearable]="true"
                                            [listUrl]="containerSizeTypeUrl"></app-mat-auto-search>
                                    </div>

                                    <!-- Container Condition -->
                                    <div fxFlex="12.3em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Condition*</span>
                                        </div>
                                        <app-mat-auto-search [isEditable]="true" fxFlex="100"
                                            [(ngModel)]="requestObj.requirements[i].condition"
                                            [errors]="requestObj.error?.requirements?.length ? requestObj.error?.requirements[i]?.condition : []"
                                            [idField]="null" [displayField]="'value'" [name]="'condition'+i"
                                            [options]="containerConditionList?.results" [clearable]="false"
                                            [trim]="true" [searchable]="false"></app-mat-auto-search>
                                    </div>

                                    <ng-container *ngIf="requestObj.request_type?.dev_name == 'buy_sell'">
                                        <!-- Purpose -->
                                        <div fxFlex="12.3em" fxLayout="column"
                                            *ngIf="requestObj.transaction_type=='use'">
                                            <div class="inputTitle">
                                                <span>Purpose of Container</span>
                                            </div>
                                            <mat-button-toggle-group name="Purpose"
                                                [(ngModel)]="requestObj.requirements[i].purpose"
                                                class="togglebtn1 cscToggle">
                                                <mat-button-toggle value="domestic">Domestic</mat-button-toggle>
                                                <mat-button-toggle value="export">Export</mat-button-toggle>
                                            </mat-button-toggle-group>
                                        </div>

                                        <!-- CSC Revalidation -->
                                        <div fxFlex="13.3em" fxLayout="column">
                                            <div class="inputTitle">
                                                <span>With CSC revalidation <i
                                                        matTooltip="Select Yes if you want to buy/sell with CSC Revalidation"
                                                        matTooltipPosition="right" class="flaticon-message"></i></span>
                                            </div>
                                            <mat-button-toggle-group [name]="'csc_revalidation_required'+i"
                                                [(ngModel)]="requestObj.requirements[i].csc_revalidation_required"
                                                class="togglebtn1 cscToggle">
                                                <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                                                <mat-button-toggle [value]="false">No</mat-button-toggle>
                                            </mat-button-toggle-group>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="requestObj.request_type?.dev_name == 'lease'">
                                        <!-- Leasing period -->
                                        <div fxFlex="12.3em" fxLayout="column">
                                            <div class="inputTitle">
                                                <span>Leasing period (Days)*</span><i MatSuffix
                                                    matTooltip="Enter the leasing period, for which you want to lease the container."
                                                    matTooltipPosition="right" matTooltipHideDelay="2000"
                                                    class="flaticon-message"></i>
                                            </div>
                                            <app-number-field [isEditable]="true"
                                                [(ngModel)]="requestObj.requirements[i].leasing_period_days"
                                                [name]="'leasingDays'+i" [noDecimal]="true"
                                                [errors]="requestObj.error?.requirements?.length ? requestObj.error?.requirements[i]?.leasing_period_days : ['']"
                                                [minValue]="0" [maxValue]="99999" [maxlength]="5"></app-number-field>
                                        </div>

                                        <!-- Per Diem -->
                                        <div fxFlex="12.3em" fxLayout="column">
                                            <div class="inputTitle">
                                                <span>Per Diem Charge</span>
                                            </div>
                                            <app-new-money-field fxLayout="column" [isEditable]="true" [minValue]="0"
                                                [(amount)]="requestObj.requirements[i].per_diem"
                                                [(currency)]="requestObj.requirements[i].per_diem_currency"
                                                [errors]="requestObj.error?.requirements?.length ? requestObj.error?.requirements[i]?.per_diem : ['']"></app-new-money-field>
                                        </div>
                                    </ng-container>

                                    <div class="actionBtn">
                                        <i class="flaticon-delete" (click)="removeRequirements(i)" matTooltip="Delete"
                                            matTooltipPosition="below" matTooltipHideDelay="2000"
                                            *ngIf="requestObj.requirements.length>1"></i>
                                    </div>
                                </div>
                            </div>
                            <span class="addReq" *ngIf="requestObj.request_type?.dev_name == 'lease'"
                                (click)="addRequirements()" matTooltip="Add more requirement" matTooltipPosition="left"
                                matTooltipHideDelay="2000">Add</span>
                        </div>
                    </div>
                    <!-- POL/POD -->
                    <div class="locationBox" fxFlex="100" fxLayout="row">
                        <div fxFlex="100" fxLayout="column">
                            <app-super-location [isEditable]="isRequestEditable" [label]="superLocationSourceLabel+'*'"
                                [(ngModel)]="requestObj.pol_list"
                                (ngModelChange)="resetPolsError($event)"></app-super-location>
                            <div class="port-errors">
                                <li *ngFor="let error of requestObj.error.pol_list">
                                    {{error}}
                                </li>
                            </div>
                        </div>
                        <ng-container *ngIf="!(requestObj.request_type?.dev_name=='buy_sell')">
                            <div fxFlex="100" fxLayout="column">
                                <app-super-location [isEditable]="isRequestEditable"
                                    [label]="superLocationDestinationLabel+'*'" [(ngModel)]="requestObj.pod_list"
                                    (ngModelChange)="resetPodsError($event)"></app-super-location>
                                <div class="port-errors">
                                    <li *ngFor="let error of requestObj.error.pod_list">
                                        {{error}}
                                    </li>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Email -->
                    <div class="emailId" fxLayout="column">
                        <div class="inputTitle">
                            <span>Email ID*</span>
                        </div>
                        <app-text-field [isEditable]="isRequestEditable" [ngModel]="requestObj.email"
                            (ngModelChange)="setEmail($event)" [(errors)]="requestObj.error.email"></app-text-field>
                    </div>

                    <!-- Phone number -->
                    <div fxFlex="12.3em" fxLayout="column" class="step1pn">
                        <div class="inputTitle">
                            <span>Mobile Number*</span>
                        </div>
                        <app-phone-field [isEditable]="isRequestEditable" class="align-items-center"
                            [ngModel]="requestObj.mobile" (ngModelChange)="setCountryByMobileNumber($event)"
                            [(errors)]="requestObj.error.mobile" placeholder="XXXXXXXXXX"></app-phone-field>
                    </div>
                </div>
                <div fxFlex="100" [class.showRequirements]="!step1" class="inputs" *ngIf="!step1">
                    <div class="showCase showCaseLeft">
                        <!-- {{requestObj?.requirements?.length > 1 ?
                        '+'+(requestObj?.requirements?.length-1)+' more':''}} -->
                        <span class="title">Equipment
                            <i class="flaticon-container-solid"></i></span>
                        <div fxLayout="row">
                            <span class="subTitled">Quantity * Type ( Condition) :</span>
                            <span class="data">
                                <span *ngFor="let reqObj of requestObj?.requirements; index as i ">
                                    {{requestObj?.requirements[i].quantity}}
                                    * {{requestObj?.requirements[i].container_size_type?.display}}(
                                    {{requestObj?.requirements[i].condition?.value}})</span>
                            </span>
                        </div>
                        <!-- <div fxLayout="row">
                            <span class="subTitled">Condition</span><span class="data">:
                                {{requestObj?.requirements?.length > 0 ?
                                requestObj?.requirements[0].condition?.value:''}}</span>
                        </div> -->
                    </div>
                    <div class="showCase showCaseRight">
                        <span class="title">Location Details <i class="flaticon-world-map"></i></span>
                        <div fxLayout="row" fxFlex="100">
                            <span class="subTitled">{{superLocationSourceLabel}} :</span>
                            <span class="data">
                                <ng-container *ngIf="requestObj?.pol_list?.length">
                                    <span>{{requestObj?.pol_list[0].name_display}}</span>
                                    <span *ngIf="requestObj?.pol_list?.length > 1">
                                        {{requestObj?.pol_list[1].name_display}}</span>
                                    <span *ngIf="requestObj?.pol_list?.length > 2">
                                        {{requestObj?.pol_list[2].name_display}}</span>
                                    <span *ngIf="requestObj?.pol_list?.length > 3">
                                        {{requestObj?.pol_list[3].name_display}}</span>
                                    <span *ngIf="requestObj?.pol_list?.length > 4">
                                        {{requestObj?.pol_list[4].name_display}}</span>
                                    <span *ngIf="requestObj?.pol_list?.length > 5">
                                        {{requestObj?.pol_list[5].name_display}}</span>
                                    <!-- <div *ngIf="requestObj?.pol_list?.length > 1 && requestObj?.pol_list?.length < 2"
                                        [matTooltip]="requestObj?.pol_list | tooltipList "
                                        matTooltipClass="tooltip-list">+
                                        {{requestObj?.pol_list?.length - 3}} more</div> -->
                                    <div *ngIf="requestObj?.pol_list?.length > 6"
                                        [matTooltip]="requestObj?.pol_list | tooltipList "
                                        matTooltipClass="tooltip-list">+
                                        {{requestObj?.pol_list?.length - 6}} more</div>
                                </ng-container> </span>
                        </div>
                        <div *ngIf="requestObj.request_type?.dev_name!='buy_sell'" fxLayout="row" fxFlex="100">
                            <span class="subTitled">{{superLocationDestinationLabel}} :</span>
                            <span class="data">
                                <ng-container *ngIf="requestObj?.pod_list?.length">
                                    <span>{{requestObj?.pod_list[0].name_display}}</span>
                                    <span *ngIf="requestObj?.pod_list?.length > 1">
                                        {{requestObj?.pod_list[1].name_display}}</span>
                                    <span *ngIf="requestObj?.pod_list?.length > 2">
                                        {{requestObj?.pod_list[2].name_display}}</span>
                                    <span *ngIf="requestObj?.pod_list?.length > 3">
                                        {{requestObj?.pod_list[3].name_display}}</span>
                                    <span *ngIf="requestObj?.pod_list?.length > 4">
                                        {{requestObj?.pod_list[4].name_display}}</span>
                                    <span *ngIf="requestObj?.pod_list?.length > 5">
                                        {{requestObj?.pod_list[5].name_display}}</span>
                                    <!-- <div *ngIf="requestObj?.pod_list?.length > 1 && requestObj?.pod_list?.length < 2"
                                        [matTooltip]="requestObj?.pod_list | tooltipList "
                                        matTooltipClass="tooltip-list">+
                                        {{requestObj?.pod_list?.length - 3}} more</div> -->
                                    <div *ngIf="requestObj?.pod_list?.length > 6"
                                        [matTooltip]="requestObj?.pod_list | tooltipList "
                                        matTooltipClass="tooltip-list">+
                                        {{requestObj?.pod_list?.length - 6}} more</div>
                                </ng-container> </span>
                        </div>
                    </div>
                </div>
                <div class="btnb" *ngIf="step1">
                    <button mat-raised-button [class.addBtn]="!disableRequestProceedButton"
                        [disabled]="disableRequestProceedButton" (click)="saveRequest()">{{requestObj.id != null ?
                        'Update' : 'Proceed'}}</button>
                </div>
            </div>
            <div class="wrap" *ngIf="step2">
                <label class="stepHead">Tell us more about yourself</label>
                <!-- <label class="stepHead">Personal</label> -->
                <div fxFlex="100" class="inputs" style="row-gap: 1em;">
                    <div fxLayout="row" fxFlex="100" class="email">
                        <!-- <i [class.flaticon-email]="!isEmailEditable"></i> -->
                        <app-text-field [isEditable]="isEmailEditable" class="align-items-center" placeholder="Email*"
                            [class.emailupdate]="true" [emailIcon]="true" [(ngModel)]="registerObj.email"
                            [(errors)]="registerObj.errors.email"></app-text-field>
                        <i [ngClass]="!isEmailEditable ? 'flaticon-pencil' : 'flaticon-checked'"
                            [class.editor]="isEmailEditable" [matTooltip]="emailToolTip" matTooltipPosition="right"
                            (click)="toggleEmailEditing(registerObj.email)"></i>
                    </div>

                    <!-- First Name -->
                    <div fxFlex="15em" fxLayout="column">
                        <div class="inputTitle">
                            <span>First Name*</span>
                        </div>
                        <app-text-field [isEditable]="true" [name]="'first_name'" [(ngModel)]="registerObj.first_name"
                            [minlength]="3" [specailChar]="true" [(errors)]="registerObj.errors.first_name">
                        </app-text-field>
                    </div>

                    <!-- Last Name -->
                    <div fxFlex="15em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Last Name*</span>
                        </div>
                        <app-text-field [isEditable]="true" [name]="'last_name'" [(ngModel)]="registerObj.last_name"
                            [minlength]="3" [specailChar]="true" [(errors)]="registerObj.errors.last_name">
                        </app-text-field>
                    </div>


                    <div fxFlex="100" class="inputs">
                        <app-text-field [isEditable]="true" [label]="'Company Name*'" [name]="'company_name'"
                            [(ngModel)]="registerObj.company_name" [minlength]="3" fxFlex="12em" class="address"
                            [(errors)]="registerObj.errors.company_name">
                        </app-text-field>

                        <app-mat-auto-search [isEditable]="true" [label]="'Country*'" [name]="'country'"
                            [listUrl]="country_url" [setSearchValue]="false" [ngModel]="registerObj.country"
                            (ngModelChange)="filterStates($event)" fxFlex="12em" [idField]="null"
                            [displayField]="'name'" [errors]="registerObj.errors.country" [disabled]="disableFields">
                        </app-mat-auto-search>


                        <app-mat-auto-search [label]="'State*'" [isEditable]="true" [name]="'state'"
                            [(ngModel)]="registerObj.state" (ngModelChange)="onStateChange($event)" [idField]="null"
                            [setSearchValue]="false" [displayField]="'name'" [listUrl]="state_url" fxFlex="12em"
                            [errors]="registerObj.errors.state" [disabled]="disableFields">
                        </app-mat-auto-search>


                        <app-text-field [isEditable]="true" [label]="'Address'" [name]="'address'"
                            [(ngModel)]="registerObj.address" [isMultiline]="true" [minlength]="5" fxFlex="18em"
                            class="address" [errors]="registerObj.errors.address" [disabled]="disableFields">
                        </app-text-field>
                    </div>
                </div>
                <div fxFlex="100" class="btn2" fxLayout="row">
                    <button mat-raised-button class="Cancel" (click)="setStep('step1')">Back</button>
                    <button mat-raised-button [class.addBtn]="!disableBasicDetailsProceedButton"
                        [disabled]="disableBasicDetailsProceedButton" (click)="sendOtp()">Proceed & Send OTP</button>
                </div>
            </div>
            <div class="wrap" [class.wrapPlus]="isEmailVerified" *ngIf="step3">
                <ng-container *ngIf="!isEmailVerified">
                    <label class="stepHead">Email Verification</label>

                    <ng-container *ngIf="!isOtpVerified">
                        <div class="otpContext">
                            <span>OTP has been sent on <b>{{registerObj?.email}}</b>.</span>
                            <span style="font-size: 12px;"> Please check your inbox or SPAM folder and enter the OTP to
                                complete your account creation.</span>
                        </div>
                        <div fxFlex="100" class="inputs" style="    margin-top: 12px;">
                            <app-text-field [isEditable]="true" [(ngModel)]="otp_obj.otp" class="otpInput"
                                placeholder="OTP" fxFlex="12em" [(errors)]="otp_obj.errors.otp"></app-text-field>
                            <button class="Save sleekBtn" style="align-self: self-end;
                            margin-bottom: 5px;" mat-raised-button *ngIf="resendOtp"
                                (click)="resendOtpOnEmail()">Resend OTP</button>
                        </div>
                        <span *ngIf="displayTimer" [class.resendOtpMargin]="otp_obj.errors.otp" class="resendOtp">Resend
                            OTP in <span class="otp">
                                {{display}}</span></span>
                        <!-- <span *ngIf="resendOtp" (click)="resendOtpOnEmail()" class="clickResend">Click here to resend
                            OTP</span> -->
                        <div class="btnb">
                            <button mat-raised-button class="Cancel" (click)="backFromOtpDetails()">Back</button>
                            <button mat-raised-button [class.addBtn]="!disableVerifyButton"
                                [disabled]="disableVerifyButton" (click)="verifyOtp()">Verify</button>
                        </div>
                    </ng-container>

                    <!-- Password -->
                    <!-- <ng-container *ngIf="isOtpVerified">
                        <div class="password" fxLayout=" row" fxFlex="100">
                            <div fxFlex="15em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Password*</span>
                                </div>
                                <app-password-field [isEditable]="true" [(ngModel)]="otp_obj.password"
                                    [(errors)]="otp_obj.errors.password"></app-password-field>
                            </div>
                            <div fxFlex="15em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Confirm Password*</span>
                                </div>
                                <app-password-field [isEditable]="true" [(ngModel)]="otp_obj.password_confirm"
                                    [(errors)]="otp_obj.errors.password_confirm"></app-password-field>
                            </div>
                        </div>
                        <logzy-password-strength-meter
                            [passwordToCheck]="otp_obj.password"></logzy-password-strength-meter>
                        <div class="tnc" fxFlex="100">
                            <mat-checkbox color="primary">I've read the <a
                                    href="https://arconcontainer.com/#/terms-of-service "><i>terms and
                                        conditions</i></a> and abide by the
                                platform's data rules.
                            </mat-checkbox>
                        </div>
                        <div class="btnb">
                            <button mat-raised-button [class.addBtn]="!disableSetPasswordProceedButton"
                                [disabled]="disableSetPasswordProceedButton" (click)="setPassword()">Proceed</button>
                        </div>
                    </ng-container> -->

                </ng-container>
                <ng-container *ngIf="isEmailVerified">
                    <!-- <img class="verified" [class.vfstart]="verifyAnimate" src="assets\images\web-portal\verified2.gif"
                        loop="false" alt=""> -->
                    <video src="assets/images/web-portal/verified.mp4" class="verified" width="320" height="240"
                        autoplay muted type="video/mp4" *ngIf="showVideo">
                        Your browser does not support the video tag.
                    </video>
                    <div class="confirmationDetails" [class.animationDetails]="verifyAnimate">
                        <div class="set1"><i class="flaticon-user2"></i> <span> {{verificationResponse?.first_name}}
                                {{verificationResponse?.last_name}}</span></div>
                        <div class="set2"><i class="flaticon-office"></i> <span> {{verificationResponse?.company}},
                                {{verificationResponse?.country}}</span></div>
                        <div class="set3"><i class="flaticon-checked2"></i> <span> Setting up your account</span></div>
                    </div>
                    <div class="confirmationText" [class.animationDetails]="verifyAnimate">
                        <span class="confHead">
                            Email Verified!
                        </span>
                        <!-- <span class="text-muted mat-subheading-2 fs-13">Your email has been verified</span> -->
                        <span class="text-muted mat-subheading-2  confLogin confError" *ngIf="showError">You will be
                            notified once company admin approves your login request.</span>
                        <!-- <img class="waitForAprv" *ngIf="showError" src="assets\images\web-portal\waitForAprv.png"> -->
                        <span class="text-muted mat-subheading-2  confLogin" *ngIf="!showError">
                            Kindly login immediately to proceed with the current request.
                            <a href="/authentication/login">Login Here</a></span>
                    </div>
                    <!-- <div class="btnb">
                        <button mat-raised-button class="addBtn" (click)="navigateToLogin()">Click here to
                            Login</button>
                    </div> -->
                </ng-container>
            </div>
            <img class="otpVideo" *ngIf="step3 && !isOtpVerified" src="assets\images\web-portal\otpv.gif">
        </mat-card-content>
    </mat-card>
</div>

<!-- Company template for dropdown -->
<ng-template #companyItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="companyListShow">
        <span class="branch">
            {{item?.name}}
        </span>
        <span class="address">
            {{item?.primary_branch?.address}}
        </span>
    </div>
</ng-template>

<ng-template #companySelectedItem let-item>
    {{item?.name}}
</ng-template>

<ng-template #companyDisplayItem let-item>
    {{item?.unit_name?.value}}<br>
    <small>{{item?.address}}</small>
</ng-template>